// src/Auth.js
import React from 'react';
import { Navigate } from 'react-router-dom';

export function RequireAuth({ children }) {
  const admin = JSON.parse(localStorage.getItem('admin'));
  return admin ? children : <Navigate to="/login" replace />;
}

export function useAdmin() {
  return JSON.parse(localStorage.getItem('admin'));
}
